// This file contains a monkey patch for Ant Design's Upload component
// to fix the "(fileList || []).forEach is not a function" error

// Apply this patch when the application loads
export function applyAntDesignFixes() {
    // Monkey patch Array.isArray to handle special objects that might be passed to the Upload component
    const originalIsArray = Array.isArray;
    
    // Override Array.isArray to handle potential non-array objects
    // Use a type predicate to satisfy TypeScript
    Array.isArray = function(obj): obj is any[] {
        if (obj && typeof obj === 'object' && !originalIsArray(obj) && obj.forEach) {
            // If it has a forEach method but isn't an array, return true to make it be treated as an array
            return true;
        }
        return originalIsArray(obj);
    };
    
    console.log('Applied Ant Design Upload component fix');
}

// The error occurs because some component is passing a non-array object 
// to the Upload component, which expects an array for the fileList prop 